export default __webpack_public_path__ + "static/media/556.2a62ef03.jpg";